import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import TabPanel from '@mui/lab/TabPanel';

import SoapEntry from '../SoapEntry/SoapEntry';
import SoapPast from '../SoapPast/SoapPast';

import {
  getSoapEntryColumnSx,
  getSoapGridSx,
  getSoapPastColumnSx,
  tabPanelSx
} from './SoapLeftStyles';

const SoapTabPanel = ({
  isPast,
  setPast,
  encounters,
  onSaveEncounter,
  onSignEncounter
}) => {
  return (
    <TabPanel
      value="1"
      sx={tabPanelSx}>
      <Box sx={getSoapGridSx(isPast)}>
        <Box sx={getSoapEntryColumnSx(isPast)}>
          <SoapEntry
            isPast={isPast}
            setPast={setPast}
            onSaveEncounter={onSaveEncounter}
            onSignEncounter={onSignEncounter}
          />
        </Box>

        <Box sx={getSoapPastColumnSx(isPast)}>
          <SoapPast
            isPast={isPast}
            setPast={setPast}
            encounters={encounters}
            onSignEncounter={onSignEncounter}
          />
        </Box>
      </Box>
    </TabPanel>
  );
};

SoapTabPanel.propTypes = {
  isPast: PropTypes.bool.isRequired,
  setPast: PropTypes.func.isRequired,
  encounters: PropTypes.array.isRequired,
  onSaveEncounter: PropTypes.func.isRequired,
  onSignEncounter: PropTypes.func.isRequired
};

export default SoapTabPanel;